import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components/macro";

import SignupsDownForMaintenance from "UI/FnrDownForMaintenance/SignupsDownForMaintenance.js";

import Portal from "Utilities/PortalMaker";
import { usePortalElement } from "Utilities/PortalMaker/usePortalElement";

import Intro from "./Intro";
import "./SignupApp.scss";
import SignupListsHolder from "./SignupListsHolder";
import SignupView from "./SignupView";
import { NewSignupCreationFlowProvider } from "./SignupView/NewSignup";
import { SignupsAppState } from "./state.js";
import useDisplayFamilyReg from "./utils/useDisplayFamilyReg.js";

export default function SignupsInSystem() {
  const [
    { allSignupLists, user, canViewFamilyRegistrationAdminPanel },
    dispatch,
  ] = useContext(SignupsAppState);

  let { signupListID, action } = useParams();

  // if no signups, but family reg is enabled, show family reg which is inside SignupViews
  const displayFamilyReg = useDisplayFamilyReg();

  if (signupListID === "new" && !action) action = "new";
  else if (signupListID === "family-registration")
    action = "family-registration";

  // if (signupListID === "family-registration") {
  //   showFamilyRegistration = true;
  //   dispatch({ type: "Remove Current Signup List" });
  // }
  // else
  if (isNaN(signupListID)) signupListID = null;

  useEffect(() => {
    if (!signupListID && !action)
      dispatch({ type: "Remove Current Signup List" });
  }, [signupListID, action, dispatch]);

  const signupPortalElement = usePortalElement(".page_network_signups.on");

  const displaySignupView = signupListID || action || displayFamilyReg;
  const showCreateButton = allSignupLists && allSignupLists.length === 0;

  // const DownForMaintenance = () => {
  //   if (!signupPortalElement) return null;

  //   return (
  //     <NewSignupCreationFlowProvider>
  //       <Portal to={signupPortalElement}>
  //         <div className="SignupApp">
  //           <InnerWrapper>
  //             <SignupsDownForMaintenance />
  //           </InnerWrapper>
  //         </div>
  //       </Portal>
  //     </NewSignupCreationFlowProvider>
  //   );
  // };

  // return DownForMaintenance();
  return signupPortalElement ? (
    <NewSignupCreationFlowProvider>
      <Portal to={signupPortalElement}>
        <div className="SignupApp" data-cy="SignupInSystem_Container">
          <InnerWrapper>
            <SignupListsHolder signupListID={signupListID} action={action} />
            {displaySignupView ? (
              <SignupView signupListID={signupListID} action={action} />
            ) : (
              <IntroWrapper
                className="signups_in_system_wrapper"
                verticalCenter={!canViewFamilyRegistrationAdminPanel}
                data-cy="SignupsInSystem_IntroWrapper"
              >
                <Intro
                  showCreateButton={showCreateButton}
                  show={allSignupLists}
                />
              </IntroWrapper>
            )}
          </InnerWrapper>
        </div>
      </Portal>
    </NewSignupCreationFlowProvider>
  ) : null;
}

const InnerWrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const IntroWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.verticalCenter ? "center" : "flex-start"};

  @media (max-height: 560px) {
    justify-content: flex-start;
  }

  @media (max-width: 840px) {
    height: auto;
    min-height: 100vh;
  }
`;
